import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';

class Landing extends Component {
    constructor(props) {
        super(props);
    }

    navigateTo(location, event) {
        event.preventDefault();
        browserHistory.push(location);
    }

    render() {
        return (
            <div className="landing">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card-slim">
                            <div className="text-center">
                                <div className="avatar merchant" />
                                {this.props.core.merchantInfo ? (
                                    <div>
                                        <h3>{this.props.core.merchantInfo.name}</h3>
                                    </div>
                                ) : null}
                            </div>
                        </div>
                        <div className="row menu-controls">
                            <div className="col-xs-4">
                                <div className="tile" onClick={this.navigateTo.bind(this, '/profile')}>
                                    <p>
                                        <i className="fa fa-user" />
                                        <span>My Profile</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="tile" onClick={this.navigateTo.bind(this, '/jobs')}>
                                    <p>
                                        <i className="fa fa-wrench" />
                                        <span>Open Jobs</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="tile" onClick={this.navigateTo.bind(this, '/jobs/closed')}>
                                    <p>
                                        <i className="fa fa-history" />
                                        <span>Closed Jobs</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="tile" onClick={this.navigateTo.bind(this, '/terminals')}>
                                    <p>
                                        <i className="fa fa-credit-card" />
                                        <span>Terminals</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="tile" onClick={this.navigateTo.bind(this, '/contactus')}>
                                    <p>
                                        <i className="fa fa-phone" />
                                        <span>Contact Support</span>
                                    </p>
                                </div>
                            </div>
                            <div className="col-xs-4">
                                <div className="tile disabled">
                                    <p>
                                        <i className="fa fa-comments" />
                                        <span>Web Chat</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        core: state.core
    };
}

export default connect(mapStateToProps)(Landing);


// WEBPACK FOOTER //
// ./app/core/components/landing.js